module.exports = __webpack_public_path__ + "media/country_flags/sc-577f11c9.png";